import { Component, OnInit } from '@angular/core';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-profilo-utente',
  templateUrl: './profilo-utente.component.html',
  styleUrls: ['./profilo-utente.component.css']
})
export class ProfiloUtenteComponent extends AppComponentGenericComponent implements OnInit {
	constructor(protected dataService: DataService) {
	    super(dataService, 'profilo-utente');
	}

	ngOnInit() {
	}

	salvaProfiloUtente() {
	}
}
